export default __webpack_public_path__ + "static/media/book.efb72049.svg";